export default __webpack_public_path__ + "static/media/_british-antarctic-territory.a4d5ddc2.ico";